namespace('compass.hotel');
compass.requireLib('compass.util.format');

compass.hotel.HotelPromoWidget = compass.defineWidget(function HotelPromoWidget(options) {
	var me = this;
	var $j = jQuery;

	var _settings = options;

	var onPeakDefaultPromotions = _settings.defaultPromotions;

	var _grabValues = this.grabValues = function() {
		var jsonValues = {};
		return jsonValues;
	};

	this.validate = function() {
		this.validator.validateAll();
		return this.validator.valid;
	};

	this.destroyWidget = function() {
	};

	var _render = this.render = function(widgetElem) {
		var d = _d;

		/*PROMOTIONS */
		if(_settings.promos.length > 0) {
			var customPromos = [];
			var onPeakPromos = [];
			// TODO: Once legacy internal incentive page is retired, we can filter between custom and onpeak incentives by just looking for html elements.  Till then we need to look at both type and verbiage
			// _.each(_settings.promos, function(promo) {
			// 	/<\/?[a-z][\s\S]*>/i.test(promo) ? customPromos.push(promo) : onPeakPromos.push(promo);
			// })
			// Until legacy internal incentive is retired, sort out onpeak incentives by comparing against default descriptions
			_.each(_settings.promos, function(promo) {
				return onPeakDefaultPromotions.includes(promo) ? onPeakPromos.push(promo) : customPromos.push(promo);
			});
			var promoOutput = _drawPromotions('Exclusive Promotions', onPeakPromos.concat(customPromos));
			widgetElem.append(promoOutput);
		}

		var extrasArray = _.filter(_settings.amenities, function(thisAmenity){return thisAmenity.type.toUpperCase() == "HOTEL EXTRAS";});

		if(extrasArray.length > 0 && !_settings.hideHotelExtras) {
			var extrasOutput = _drawExtras('Hotel Extras', extrasArray);
			widgetElem.append(extrasOutput);
		}

	};

	var _drawPromotions = function(title, promos){
		var d = _d;

		return d.div({ className : 'promos' }, title,
			_.map(promos, function(promo) { return d.div({ className : 'promo hotelInfoPromo' }, promo); })
		);
	};

	var _drawExtras = function(title, extras){
		var d = _d;

		var extrasArray = _.map(extras, function(thisExtra){
			return d.div({ className : 'extra' }, thisExtra.name);
		});
		return d.div({ className : 'extras' }, title, extrasArray);
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'CRAP',
	widgetName : 'HotelPromoWidget',
	imgPath : '/resources/img',
	promos : [],
	currencySymbol : '$'
});

